
import { Component, Vue } from 'vue-property-decorator';
import { eNewaddActive } from '@/interface/newadd-active';
import { getUserAlive } from '@/api/statistics';
import { iSelectOptionsList } from '@/interface/cancel-detail';
import ShortcutDate from '@/components/shortcutdate/shortcutdate.vue';
@Component({
  components: { ShortcutDate },
})
export default class UserRemain extends Vue {
  private dataDefault: Date = new Date();
  datas: Array<any> = [];

  loading: boolean = false; //加载数据中
  total: number = 0; //总条数
  columnLabel: string = '新增用户';
  newUser: eNewaddActive = eNewaddActive.NEW_USER; //新用户留存
  activeUser: eNewaddActive = eNewaddActive.ACTIVE_USER; //活跃用户留存
  chargeUser: eNewaddActive = eNewaddActive.CHARGE_USER; //充值用户留存
  consumeUser: eNewaddActive = eNewaddActive.CONSUME_USER; //消费用户留存
  defaultDays: { day: number; initDay: number } = { day: 7, initDay: 0 }; // 默认近7天
  params: { start: number; end: number; page?: number; page_size?: number; type: eNewaddActive } = {
    start: 0,
    end: 0,
    page: 1,
    page_size: 10,
    type: eNewaddActive.NEW_USER,
  };
  public dates: (string | Date)[] = [];
  private pickerBeginDateBefore: { disabledDate: Function } = {
    disabledDate(time: any) {
      return time.getTime() > Date.now();
    },
  };
  private initDay: string | number = 0;
  //快捷日期:
  private shortcutDays: iSelectOptionsList[] = [
    { label: '最近7天', value: 7 },
    { label: '最近30天', value: 30 },
  ];
  getShortcutTimeFn(dates: (string | Date)[], params: { start: number; end: number }, activeIndex: number) {
    this.initDay = activeIndex;
    this.dates = dates;
    this.params.start = params.start;
    this.params.end = params.end;
    this.params.page = 1;
    this.getData();
  }
  dateHandler(datavalue: Date[]) {
    this.initDay = '';
    this.params.start = Math.floor(datavalue[0].getTime() / 1000);
    this.params.end = Math.floor(datavalue[1].getTime() / 1000) + 3600 * 24 - 1;
    this.params.page = 1;
    this.getData();
  }
  /**
   * 切换选项卡
   */
  handleClick() {
    // this.params.type = tab;
    this.getData();
  }
  handleSizeChange(page_size: number) {
    this.params.page = 1;
    this.params.page_size = page_size;
    this.getData();
  }
  handleCurrentChange(page: number) {
    this.params.page = page;
    this.getData();
  }
  /**
   * 获取数据
   */
  async getData() {
    try {
      this.loading = true;
      let res = await getUserAlive(this.params);
      if (res && res.code == 0) {
        this.datas = res.data.list;
        this.total = res.data.total;
        switch (this.params.type) {
          case 'new_user':
            this.columnLabel = '新增用户';
            break;
          case 'active_user':
            this.columnLabel = '活跃用户';
            break;
          case 'charge_user':
            this.columnLabel = '充值用户';
            break;
          case 'consume_user':
            this.columnLabel = '消费用户';
            break;
        }
      }
      this.loading = false;
    } catch (error) {
      this.loading = false;
    }
  }
}
